import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch"

const deleteTask = (
    backend: string,
    token: string,
    id: number
) => {
 
    return fetch(
        
        `${getApiUrl(backend)}tasks/${id}`,
        {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
        }
    );
};

export default deleteTask